import React, { useRef } from 'react'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Button } from 'reactstrap';

const TestPDF = () => {
    const pdfRef = useRef();
  const downloadPDF = () => {
    const input = pdfRef.current;
    html2canvas(input).then(canvas => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4", true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 30;
      pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );
      pdf.save("invoice.pdf");
    });
  };
  return (
    <div className='page-content'>
        <div ref={pdfRef}>
            Content
            fekkmgoieamoga
        </div>
        <Button color="primary" onClick={downloadPDF}>
            DowloadPDF
        </Button>
    </div>
  )
}

export default TestPDF